export default "__VITE_ASSET__lakTmlba__"